import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { CaseAcquisitionStatus, MyCasesData } from '../../../service/cases.service';

export type MoveEvent = {
  previousStatus: CaseAcquisitionStatus;
  currentStatus: CaseAcquisitionStatus;
  lead: MyCasesData;
  previousIndex: number;
  currentIndex: number;
};

@Component({
  selector: 'app-kanban-column',
  templateUrl: './kanban-column.component.html',
  styleUrls: ['./kanban-column.component.scss'],
})
export class KanbanColumnComponent {
  @Input() title!: CaseAcquisitionStatus;
  @Input() status!: CaseAcquisitionStatus;

  @Input() leads: MyCasesData[] = [];
  @Input() connectedTo: string[] = [];

  @Output() moved = new EventEmitter<MoveEvent>();

  get dropListId(): string {
    return `drop-${this.status}`;
  }

  drop(event: CdkDragDrop<MyCasesData[]>) {
    const lead = event.item.data as MyCasesData;
    const previousStatus = this.parseStatusFromId(event.previousContainer.id);

    this.moved.emit({
      previousStatus,
      currentStatus: this.status,
      lead,
      previousIndex: event.previousIndex,
      currentIndex: event.currentIndex,
    });
  }

  private parseStatusFromId(id: string): CaseAcquisitionStatus {
    const raw = id.replace('drop-', '');
    return raw as CaseAcquisitionStatus;
  }

  trackByLead(_: number, lead: MyCasesData) {
    return lead.id;
  }
}
